import { useState, useEffect } from 'react';
import { StorageManager } from '../utils/storageManager';

export interface ApiKeys {
  fred: string;
  finnhub: string;
  tradier: string;
  tavily: string;
}

const DEFAULT_API_KEYS: ApiKeys = { fred: '', finnhub: '', tradier: '', tavily: '' };

export function useSettings(userId?: string) {
  const storageKey = userId ? `mmo_${userId}_apiKeys` : 'macroOptix_apiKeys';

  const [apiKeys, setApiKeys] = useState<ApiKeys>(() =>
    StorageManager.safeGet<ApiKeys>(storageKey, DEFAULT_API_KEYS)
  );

  useEffect(() => {
    // userId 변경 시 (로그인/로그아웃) 해당 유저의 키로 재로드
    setApiKeys(StorageManager.safeGet<ApiKeys>(storageKey, DEFAULT_API_KEYS));
  }, [userId, storageKey]);

  const saveApiKeys = (keys: ApiKeys) => {
    setApiKeys(keys);
    StorageManager.safeSet(storageKey, keys);
  };

  return { apiKeys, saveApiKeys };
}
